import React from "react";
import { SectionsProps } from "./types";
import { MissionSections } from "./Mission";
import { IdleSections } from "./Idle";


export const Sections: React.FC<SectionsProps> = (props) => {
  const { idleDrones = [], missionDrones = [] } = props;

  return (
    <React.Fragment >
      <MissionSections drones={missionDrones} />
      <IdleSections drones={idleDrones} />
    </React.Fragment>
  );
};  